import { useEffect, useRef, useState } from "react";
import Logo from "./logo";
import Navbar from "./navbar";
import QuoteForm from "./quoteform";
import MobileNav from "./mobilenavbar";

export default function Header({ toggleModal }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const mobileMenuRef = useRef(null);

  const handleScroll = () => {
    if (window.scrollY > 50) { // You can adjust the scroll threshold as needed
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const closeMobileMenu = () => {
    setIsOpen(false);
  };

  return (
    <section
      className={`z-[111111] fixed left-0 top-0 w-full  py-3 z-50 transition-colors duration-300 ${isScrolled ? 'bg-[#110c95]  py-3' : 'bg-transparent lg:py-[20px]  md:py-4 '}`}
      id="header"
    >
      <div className="relative block w-full">
        <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
          <div className="xl:flex hidden items-center justify-between lg:grid-cols-3 gap-4">
            <div className="xl:col-span-2 col-span-12">
              <Logo />
            </div>
            <div className="xl:col-span-10 col-span-12  flex items-center items-end gap-4">
              <div className="lg:block md:block hidden">
                <Navbar />
              </div>
             
              <div className="flex gap-3">
                {/* <QuoteForm /> */}
                <button  className="relative inline-flex items-center justify-start py-2 px-8 overflow-hidden font-normal text-white transition-all duration-150 ease-in-out rounded-full    bg-transparent  border-white border  group animate-cta-btn"
                onClick={toggleModal}
                >        
                    {/* <span className="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span>
                    <span className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    </span> */}
                    <span className="relative w-full text-left transition-colors duration-200 ease-in-out group-hover:text-white">Get in Touch</span>
                </button>
              </div>
            </div>
          </div>
          <div className="xl:hidden flex items-center justify-between lg:grid-cols-2 gap-4">
            <div className="xl:col-span-2 col-span-12">
              <Logo />
            </div>
            <div className="xl:col-span-10 col-span-12 flex items-center gap-3">
              <div>
                <button
                  className="relative inline-flex items-center justify-start py-2 px-4 overflow-hidden font-semibold text-white transition-all duration-150 ease-in-out rounded-full bg-[linear-gradient(90deg,#F16500_0%,#FF9A3E_100%)] group"
                  onClick={toggleModal}
                >
                  <span className="text-[15px] relative w-full   text-left transition-colors duration-200 ease-in-out group-hover:text-white">
                  Get in Touch
                  </span>
                </button>
              </div>
              {/* <button
                onClick={isOpen ? closeMobileMenu : () => setIsOpen(true)}
                type="button"
                className="inline-flex items-center p-0 w-8 h-8 justify-center text-sm text-gray-500 rounded-lg xl:hidden"
              >
                <span className="sr-only">Toggle main menu</span>
                {isOpen
                  ? <svg style={{height:'24px', width:'24px'}}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#fffff"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="#ffffff"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  : <svg style={{height:'24px', width:'24px'}}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="#ffffff"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
                  />
                </svg>}
              </button> */}
            </div>
          </div>
          {/* <div className={`${isOpen ? "block" : "hidden"}`} ref={mobileMenuRef}>
            <MobileNav
              closeMobileMenu={closeMobileMenu}
              toggleModal={toggleModal}
            />
          </div> */}
        </div>
      </div>
     
    </section>
  );
}
